<template>
  <div class="add-usr-box">
    <div class="title">
      <h2 class="pull-left">{{roleModelLan.roleInfo}}</h2>
      <div class="btn-back pull-right">
        <button class="btn btn-info"  @click="hanldeBack">{{roleModelLan.btnBack}}</button>
      </div>
      <div class="clear"></div>
    </div>
    <div class="section row">
      <!-- 角色 -->
      <input-model 
        :label="roleModelLan.role" :placeholder="roleModelLan.pleaseEnter" 
        :errTips="roleModelLan.errTips" :data="roleId" :modelKey="'roleId'"
        :ref="'roleId'" :validateRule="'required|max:50'" :disabled="false"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 角色名称 -->
      <input-model 
        :label="roleModelLan.roleName" :placeholder="roleModelLan.pleaseEnter" 
        :errTips="roleModelLan.errTips" :data="name" :modelKey="'name'"
        :ref="'name'" :validateRule="'required|max:50'" :disabled="false"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 描述 -->
      <input-model 
        :label="roleModelLan.description" :placeholder="roleModelLan.pleaseEnter" 
        :errTips="roleModelLan.errTips" :data="description" :modelKey="'description'"
        :ref="'description'" :validateRule="'required|max:255'" :disabled="false"
        @changeData="handleChangeData" >
      </input-model>
      <div class="col-xs-12 col-lg-6"></div>
      <!-- 设置功能 -->
      <div class="col-xs-12 col-lg-8">
        <div class="form-group">
          <label>{{this.roleModelLan.setFunc}}</label>
          <el-transfer v-model="value" :data="tData" :titles="transferTitles" v-validate="'required'" name="setFunc"></el-transfer>
          <div class="err-tips" v-show="errors.has('setFunc')">{{roleModelLan.pleaseSelect}}</div>
        </div>
      </div>
      <!-- 设置只读 -->
      <div class="col-xs-12 col-lg-4">
        <div class="form-group">
          <label>{{this.roleModelLan.setReadOnly}}</label>
          <div class="checkbox" style="margin-top:0;">
            <label v-for="item in requestData.functions" style="width:100%;margin-bottom:20px">
              <input type="checkbox" v-model="readOnlyArr" :value="item.name" > {{item.name}}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button @click="saveFn" class="btn btn-primary">{{this.roleModelLan.saveBtn}}</button>
    </div>
    <modal v-model="showModal" title="Modal Title" :header="false" :footer="false" size="sm" @hide="handleModalHide">
      <p class="successful-modal" v-show="showSuccessfulModal"><i class="fa fa-check" aria-hidden="true"></i>{{modalTips}}</p>
      <p class="failed-modal" v-show="!showSuccessfulModal"><i class="fa fa-times" aria-hidden="true"></i>{{modalTips}}</p>
    </modal>
  </div>
</template>

<script>
import inputModel from 'components/inputModel'
import { Modal } from 'uiv'
import { URL_FUNCS,URL_ROLE } from 'api/api.js'
export default {
  mixins: [require("common/mixin/base.js").base({roleModelLan:"roleModel"})],
  components: {
    inputModel,
    Modal
  },
  data() {
    return {
      tData: [],
      value: [],
      roleId: '',
      name: '',
      description: '',
      readOnlyArr: [],
      responseFuncList: [],
      showModal: false,
      showSuccessfulModal: false,
      modalTips: '',
    };
  },
  created() {
    this.$http.get(URL_FUNCS).then(res => {
        if(res.data.code === 200 && res.data.data && res.data.msg === 'OK'){
          this.responseFuncList = res.data.data
          for(let i = 0; i < this.responseFuncList.length; i++){
            this.tData.push({
              key: i,
              label: this.responseFuncList[i].name
            })
          }
        }else alert(res.data.msg)
      }).catch(e => alert(e))
  },
  computed: {
    transferTitles(){ // 穿梭框标题头
      return [this.roleModelLan.existingFuncList, this.roleModelLan.selectedFuncList]
    },
    requestData() {
      let res = {
        roleId: this.roleId,
        name: this.name,
        description: this.description,
        functions: []
      }
      for(let item of this.value) {
        res.functions.push({functionID: this.responseFuncList[item].functionID,name:this.responseFuncList[item].name,readOnly: this.readOnlyArr.includes(this.responseFuncList[item].name)})
      }
      return res
    }
  },
  methods: {
    handleChangeData(val,modelKey) { // 处理子组件绑定的数据
      this[modelKey] = val
    },
    saveFn() {
      this.validateAll(() => {
        this.$http.post(URL_ROLE, this.requestData).then(res => {
          if(res.data.code === 200 && res.data.data === 'success'){
            this.showModal = true
            this.showSuccessfulModal = true
            this.modalTips = this.roleModelLan.success
          }else alert(res.data.msg)
        }).catch(e => alert(e))
      })
    },
    validateAll(success) { // 验证全部
      let p1 = this.$refs.roleId.$validator.validate()
      let p2 = this.$refs.name.$validator.validate()
      let p3 = this.$refs.description.$validator.validate()
      let p4 = this.$validator.validate()
      Promise.all([p1,p2,p3,p4]).then(res => {
        if(res.every(v => v)) success()
        else {
          this.showModal = true
          this.showSuccessfulModal = false
          this.modalTips = this.roleModelLan.errTips
        }
      })
    },
    handleModalHide() { // 处理弹窗隐藏
      if(this.showSuccessfulModal) this.$router.push('/roleMaintenance')
    },
    hanldeBack() { // 处理返回的操作
      let url = '/roleMaintenance?pageIndex='+this.$route.query.pageIndex+'&seekKey='+this.$route.query.seekKey+'&seekVal='+this.$route.query.seekVal
      this.$router.push(url)
    },
  }
};
</script>


<style lang="scss" scoped>
.add-usr-box{
  margin: 0 20px 20px;
  padding: 20px;
  border: 1px solid #ddd;
  background: #fff;
  .section{
    .form-group{
      padding-bottom: 20px;
      margin-bottom: 10px;
      position: relative;
      .err-tips{
        position: absolute;
        bottom: 0;
        left: 0;
        color: red;
      }
    }
  }
  .footer{
    margin: 20px 0;
    text-align: center;
    .btn{
      padding: 8px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/roleMaintenance/addRole.vue